// extracted by css-extract-rspack-plugin
var _1 = "hn";
var _2 = "ks";
var _3 = "kt";
var _4 = "cl";
export { _1 as "brandsContainer", _2 as "brandsPanel", _3 as "logoTileWrapper", _4 as "panelComponent" }
